import { CommonModule } from "@angular/common";
import {
  AfterViewInit,
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  Output,
  signal,
  Signal,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ToastService } from "src/app/services/toast-service/toast.service";
import { SharedModule } from "src/shared/shared.module";
import { PipesModule } from "src/utils/pipes/pipes.module";
import { DiscountCodeComponent } from "../_dialogs/discount-code/discount-code.component";
import { DrawerComponent } from "src/app/_metronic/kt/components";
declare var KTDrawer: any;

@Component({
  selector: "app-cart-summary",
  imports: [PipesModule, CommonModule, TranslateModule, SharedModule],
  templateUrl: "./cart-summary.component.html",
  styleUrl: "./cart-summary.component.scss",
})
export class CartSummaryComponent implements OnDestroy, AfterViewInit {
  ngAfterViewInit(): void {
    const drawerEl = document.getElementById("kt_drawer_cart");
    window.addEventListener("click", () => {
      //check cart drawer open|close
      const opened = drawerEl?.classList.contains("drawer-on");
      if (!opened) {
        this.removeDiscount();
      }
    });
  }
  ngOnDestroy(): void {}

  @Input() userCart: Signal<any>;

  @Output() onPayOrder = new EventEmitter();
  @Output() onUseDiscount = new EventEmitter();
  @Output() onCancelOrder = new EventEmitter();

  #dialog = inject(MatDialog);
  #toastService = inject(ToastService);
  discountCode = signal<any>(null);

  pay() {
    if (this.discountCode()) {
      this.onUseDiscount.emit(this.discountCode());
    }
    this.onPayOrder.emit(true);
  }
  cancel() {
    this.onCancelOrder.emit(true);
  }

  openDiscountCode() {
    const dialogRef = this.#dialog.open(DiscountCodeComponent, {
      width: "500px",
      // disableClose: true,
      autoFocus: true,
      data: { userCart: this.userCart() || null },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.discountCode.update((_) => result);
      }
    });
  }

  removeDiscount() {
    this.discountCode.update((_) => null);
  }
}
